import React, { useState } from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const MaintenanceScreen: React.FC = () => {
    const [maintenanceMode, setMaintenanceMode] = useState(false);

    return (
        <SiteLayout>
            <Header icon='build' title='Maintenance Système' />
            <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
                <div className="box" style={{ padding: '30px', maxWidth: '600px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <div>
                            <h4 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '5px' }}>Mode Maintenance</h4>
                            <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
                                Activez ce mode pour empêcher l'accès aux utilisateurs non-admin pendant les mises à jour.
                            </p>
                        </div>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={maintenanceMode}
                                onChange={() => setMaintenanceMode(!maintenanceMode)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    {maintenanceMode && (
                        <div className="alert alert-warning" style={{ marginTop: '20px' }}>
                            <i className="material-icons" style={{ marginRight: '10px' }}>warning</i>
                            L'application est actuellement en mode maintenance.
                        </div>
                    )}
                </div>
            </div>
        </SiteLayout>
    );
};

export default MaintenanceScreen;
